import { Form, FormField, isEmail, isNotEmpty } from "#shared/form";
import dayjs from "dayjs";

type TFillProfileForm = {
  name: string;
  email: string;
  birthDate: string;
}

export class FillProfileForm extends Form<TFillProfileForm> {
  private initialData: TFillProfileForm;

  constructor(initialData: TFillProfileForm) {

    super({
      name: new FormField<string>(initialData.name || ''),
      email: new FormField<string>(initialData.email || ''),
      birthDate: new FormField<string>(initialData.birthDate || ''),
    });

    this.initialData = initialData;

    this.formData.name.addValidator({
      message: 'Введите имя',
      validateFn: isNotEmpty
    });

    this.formData.email.addValidator({
      message: 'Введите корректный email',
      validateFn: isEmail
    });

    this.formData.birthDate.addValidator({
      message: 'Введите корректную дату рождения',
      validateFn: (value) => {
        if (!value) return true;

        const birthDate = dayjs(value);
        return birthDate.isValid();
      }
    });

    this.formData.birthDate.addValidator({
      message: 'Регистрация доступна с 18 лет',
      validateFn: (value) => {
        if (!value) return true;

        const now = dayjs();
        const birthDate = dayjs(value);
        const age = now.diff(birthDate, 'year', true);
        return age >= 18; 
      }
    });

    this.makeSnapshot();
  }

  public override reset() {
    this.formData.name.reset(this.initialData.name);
    this.formData.email.reset(this.initialData.email);
    this.formData.birthDate.reset(this.initialData.birthDate);
  }
}